import React, { CSSProperties } from 'react';
import { Modal as MuiModal } from '@material-ui/core';
import { BoxV2 as Box } from 'portal-commons';

interface ModalProps {
  open: boolean;
  testid?: string;
  style?: CSSProperties;
}

const Modal: React.FC<ModalProps> = ({ open, testid, style, children }) => {
  return (
    <MuiModal
      BackdropProps={{
        style: {
          backdropFilter: 'blur(1px)',
        },
      }}
      open={open}
      data-testid={`${testid ? testid : 'modal'}`}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 525,
          minHeight: 160,
          bg: '#FFF',
          p: '24px 32px 8px',
          ml: '85px',
          borderRadius: 10,
          '&:focus-visible': { outline: 'none' },
          ...style,
        }}
      >
        {children}
      </Box>
    </MuiModal>
  );
};

export default Modal;
